import { BankData } from '@formunauts/banking/domain';
import { Bank } from '../bank';

export abstract class CountryBankData<T = any> {
  private _countryCode: string;
  protected _banks: T[];

  constructor(countryCode: string, json: BankData<T>) {
    const { banks } = json;
    this._countryCode = countryCode;
    this._banks = banks;
  }

  public get countryCode() {
    return this._countryCode;
  }

  /**
   * @param bankId The id for the bank
   * @param branchId The id for the branch
   *
   * @returns
   * The bank identified by the given bankId and branchId.
   * If no matching bank was found, undefined is returned.
   */
  public findBank(bankId: string, branchId?: string): Bank {
    const bankData = this.findEntry(bankId, branchId);

    return bankData ? this.fromEntry(bankData) : undefined;
  }

  /**
   * @param bankId The id for the bank
   * @param branchId The id for the branch
   *
   * @returns
   * The entry from the list of banks for this country
   */
  protected abstract findEntry(bankId: string, branchId?: string): T;

  /**
   * @param entry The bank entry from which a Bank instance should be created
   *
   * @returns
   * A new instance of `Bank` from the given entry
   */
  protected abstract fromEntry(entry: T): Bank;
}
